// src/context/UnsavedChangesContext.js
import React, { createContext, useState, useContext } from 'react';

// 1. Create the context
const UnsavedChangesContext = createContext();

// 2. Create a provider component
export const UnsavedChangesProvider = ({ children }) => {
  const [isBlocked, setIsBlocked] = useState(false);

  // The value that will be supplied to any descendants
  const value = { isBlocked, setIsBlocked };

  return (
    <UnsavedChangesContext.Provider value={value}>
      {children}
    </UnsavedChangesContext.Provider>
  );
};

// 3. Create a custom hook to easily use the context
export const useUnsavedChanges = () => {
  const context = useContext(UnsavedChangesContext);
  if (context === undefined) {
    throw new Error('useUnsavedChanges must be used within a UnsavedChangesProvider');
  }
  return context;
};